// $(document).ready(function(){

//      if( $('#homepageFeaturedProduct').length > 0 ){$('#homepageFeaturedProduct').marquee({direction:'horizontal', delay:0, timing:19, speed: 1,});  }

     
//         if( $('#marquee-icon-horizontal').length > 0 ){$('#marquee-icon-horizontal').marquee({direction:'horizontal', delay:0, timing:19, speed: 1,});  }
     



       
//   });







$(document).on('change', '.VariantOption', function(){
if( $(this).children('option:selected').val() == 'none' ){
    $('.ProductNone_btn').removeClass('hidden');$('.product-form__submit').addClass('hidden');
    $('.inventoryNote ').addClass('hidden');
  $('.reset_variations').addClass('hidden');
}else{
    $('.ProductNone_btn').addClass('hidden');$('.product-form__submit').removeClass('hidden');
   $('.inventoryNote').removeClass('hidden');
  $('.reset_variations').removeClass('hidden');
}
})


$('.ProductNone_btn').click(function(e){
e.preventDefault();
  if($('.combo-box__option-list :selected').val() === 'none'){
    alert("Please select size option before adding this product");
  }

});

// $(function() {
//   $('.inventoryNote ').toggleClass('hidden');$('.reset_variations ').toggleClass('hidden');
// })

$(document).on('click', '[name="Size"]', function(){
  $(".inventoryNote ").removeClass('hidden');
})

$(document).on('click', '.reset_variations', function(){
  $('.VariantOption').val('none').trigger('change');          
});




$('.HeaderList').hover(function(){
$(this).toggleClass("activesub_menu");
 
});

$('.Submenuhover').hover(function(){
$(this).toggleClass("active");
 
});

// $(document).ready(function(){ 
// $( ".article_Column2" ).scrollTop( 300 );
// });




$(document).ready(function() {
 $('.SliderImagesWrapFetaurted').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.thumbnail-part'
});
$('.thumbnail-part').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: '.SliderImagesWrapFetaurted',
  dots: false,
  arrows: false,
  focusOnSelect: true
});
});

$(document).ready(function(){
var content = $('.BlogContainer').html();
  $('.InnerDivWrapper').html(content);
  
  
})

 // if (window.matchMedia("(max-width: 768px)").matches) {
 //    $('.heroaWrapper').not('.slick-initialized').slick({
 //      slidesToShow: 1,
 //      slidesToScroll: 1,
 //      dots: false,
 //      arrows: false,
 //      infinite: true,
 //    });
       
 //  } 
  
 //  $( window ).resize(function() {
 //    if (window.matchMedia("(max-width: 768px)").matches) {
 //      $('.heroaWrapper').not('.slick-initialized').slick({
 //        slidesToShow: 1,
 //        slidesToScroll: 1,
 //        dots: false,
 //        arrows: false,
 //        infinite: true,
 //      });

     

 //    }else{
 //    $('.heroaWrapper').slick('unslick');
  
 //    } 
 //  })



// $('.heroaWrapper').slick({
//   dots: false,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }

//   ]
// });